
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type garageRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function garageRT(): TemplateResult<garageRTRootProps> {
    return _createElement('div', { 'className': 'cm_garage vehical_dropdown' }, _createElement('a', {
        'className': 'cm_toggle-dropdown garage-button align-items-center bg-transparent d-flex default fw-semibold lh-md text-capitalize vehical_toggle',
        'title': 'Garage: ' + this.size + ' item(s)',
        'tabIndex': '0',
        'role': 'button'
    }, _createElement('div', { 'className': 'garage-icon-container' }, _createElement('div', { 'className': 'garage-icon' + (this.size ? ' filled' : '') }, [_createElement('svg', {
            'width': '30',
            'height': '24',
            'viewBox': '0 0 30 24',
            'fill': 'none',
            'xmlns': 'http://www.w3.org/2000/svg',
            'key': '3630'
        }, _createElement('path', {
            'd': 'M27.0327 17.8045H28.741C28.9064 17.8045 29.0276 17.5811 28.9945 17.3298L28.4104 11.2836C28.3112 10.4737 27.8704 9.85929 27.3303 9.80344L22.4257 9.25886L17.9841 5.1536C17.8739 5.05585 17.7416 5 17.6094 5H11.9774C11.5696 5 11.25 5.50269 11.25 6.13104V9.38453H2C1.44772 9.38453 1 9.83225 1 10.3845V16.1662C1 16.5878 1.26449 16.9642 1.66122 17.107L4.14112 18',
            'stroke': 'currentColor',
            'strokeWidth': '1.25',
            'strokeMiterlimit': '10'
        }), _createElement('path', {
            'd': 'M21.984 17.9172H9.32031',
            'stroke': 'currentColor',
            'strokeWidth': '1.25',
            'strokeMiterlimit': '10'
        }), _createElement('path', {
            'd': 'M6.64062 21C8.02134 21 9.14062 19.8857 9.14062 18.5111C9.14062 17.1365 8.02134 16.0222 6.64062 16.0222C5.25991 16.0222 4.14062 17.1365 4.14062 18.5111C4.14062 19.8857 5.25991 21 6.64062 21Z',
            'stroke': 'currentColor',
            'strokeWidth': '1.25',
            'strokeMiterlimit': '10'
        }), _createElement('path', {
            'd': 'M24.1992 21C25.5799 21 26.6992 19.8857 26.6992 18.5111C26.6992 17.1365 25.5799 16.0222 24.1992 16.0222C22.8185 16.0222 21.6992 17.1365 21.6992 18.5111C21.6992 19.8857 22.8185 21 24.1992 21Z',
            'stroke': 'currentColor',
            'strokeWidth': '1.25',
            'strokeMiterlimit': '10'
        }))]), this.size ? _createElement('span', {
        'className': 'garage-size',
        'key': '1570'
    }, [_createElement('svg', {
            'xmlns': 'http://www.w3.org/2000/svg',
            'width': '13',
            'height': '13',
            'viewBox': '0 0 13 13',
            'fill': 'none',
            'key': '16140'
        }, _createElement('circle', {
            'cx': '7',
            'cy': '7',
            'r': '6.5',
            'fill': '#FFC62F',
            'stroke': 'black'
        }), _createElement('path', {
            'd': 'M4 7L6 9L10 5',
            'stroke': '#000000',
            'strokeWidth': '1.25',
            'strokeMiterlimit': '10',
            'strokeLinecap': 'round',
            'strokeLinejoin': 'round'
        }))]) : null), _createElement('span', { 'className': 'garage-label' }, this.vehicleString.length ? _createElement('span', {
        'className': 'garage-title',
        'style': { fontSize: '12px' },
        'key': '1982'
    }, this.vehicleString) : null, !this.vehicleString.length ? _createElement('span', {
        'className': 'garage-title',
        'style': { fontSize: '15px' },
        'key': '2097'
    }, 'Select Vehicle') : null, [_createElement('svg', {
            'className': 'cm_icon cm_icon-angle right',
            'height': '20px',
            'role': 'img',
            'viewBox': '39 30 565 565',
            'aria-hidden': 'true',
            'key': '22070'
        }, _createElement('path', { 'd': 'M600,189q0-7-6-12l-28-28q-5-6-12-6t-13,6l-220,219-219-219q-5-6-13-6t-12,6l-28,28q-6,5-6,12t6,13l260,260q5,6,12,6t13-6l260-260q6-5,6-13z' }))])), [this.garageDropdown(function () {
            function repeatItems1(items, itemsIndex) {
                return [items(function () {
                        return _createElement('div', { 'className': 'garage-item form-check' }, _createElement('input', {
                            'type': 'radio',
                            'className': 'form-check-input',
                            'onClick': this.selectVehicle,
                            'readOnly': true,
                            'checked': this.isSelected
                        }), _createElement('label', {
                            'className': 'select-model form-check-label',
                            'onClick': this.selectVehicle
                        }, _createElement('div', { 'className': 'select-model_title' }, '\n            ', window.Convermax.getVehicleLabelWithoutDifferential(this.vehicle), '\n          '), this.vehicle.Differential ? _createElement('div', {
                            'className': 'select-model_differnetial',
                            'key': '405'
                        }, '\n            ', this.vehicle.Differential, '\n          ') : null), _createElement('span', {
                            'className': 'remove-model',
                            'onClick': this.removeVehicle
                        }, [_createElement('svg', {
                                'width': '14',
                                'height': '18',
                                'viewBox': '0 0 14 18',
                                'fill': 'none',
                                'xmlns': 'http://www.w3.org/2000/svg',
                                'key': '6190'
                            }, _createElement('path', {
                                'd': 'M4.06641 2.125C4.06641 1.3 4.68582 0.625 5.44288 0.625',
                                'stroke': '#4F4C4D',
                                'strokeWidth': '1.25',
                                'strokeMiterlimit': '10'
                            }), _createElement('path', {
                                'd': 'M8.19727 0.625C8.95432 0.625 9.57374 1.3 9.57374 2.125',
                                'stroke': '#4F4C4D',
                                'strokeWidth': '1.25',
                                'strokeMiterlimit': '10'
                            }), _createElement('path', {
                                'd': 'M9.57229 2.125V3.625H4.06641V2.125',
                                'stroke': '#4F4C4D',
                                'strokeWidth': '1.25',
                                'strokeMiterlimit': '10'
                            }), _createElement('path', {
                                'd': 'M8.1963 0.625H5.44336',
                                'stroke': '#4F4C4D',
                                'strokeWidth': '1.25',
                                'strokeMiterlimit': '10'
                            }), _createElement('path', {
                                'd': 'M0.625 3.625H13.0132',
                                'stroke': '#4F4C4D',
                                'strokeWidth': '1.25',
                                'strokeLinecap': 'round',
                                'strokeLinejoin': 'round'
                            }), _createElement('path', {
                                'd': 'M11.6372 6.625H2.00195V17.125H11.6372V6.625Z',
                                'stroke': '#666768',
                                'strokeWidth': '1.25',
                                'strokeLinecap': 'round',
                                'strokeLinejoin': 'round'
                            }), _createElement('path', {
                                'd': 'M5.44336 9.625V14.125',
                                'stroke': '#666768',
                                'strokeWidth': '1.25',
                                'strokeLinecap': 'round',
                                'strokeLinejoin': 'round'
                            }), _createElement('path', {
                                'd': 'M8.19727 9.625V14.125',
                                'stroke': '#666768',
                                'strokeWidth': '1.25',
                                'strokeLinecap': 'round',
                                'strokeLinejoin': 'round'
                            }))]));
                    }, { count: undefined })];
            }
            function onClick2() {
                window.Convermax.openGarageDialog('cm_vehicle-search');
            }
            function onClick3() {
                window.Convermax.openGarageDialog('cm_vehicle-search');
            }
            return _createElement('div', { 'className': 'toggle-content cm_garageDropdown' }, this.template === 'list' ? _createElement('div', {
                'className': 'cmTemplate_list',
                'key': '46'
            }, _createElement('div', { 'className': 'vehical_title' }, _createElement('span', {}, 'Search parts for:')), _createElement('div', { 'className': 'garage-content' }, _createElement.apply(this, [
                'div',
                { 'className': 'cmRepeater_items' },
                _map(this.items, repeatItems1.bind(this))
            ]), _createElement('div', {
                'className': 'add-vehicle btn-sm btn btn-primary',
                'onClick': onClick2.bind(this)
            }, [window.Convermax.config?.garageButtonText || _translate(`garage_add_button`)]))) : null, this.template === 'empty' ? _createElement('div', {
                'className': 'cmTemplate_empty',
                'key': '3994'
            }, _createElement('div', { 'className': 'vehical_title' }, _createElement('span', {}, 'search parts for:')), _createElement('div', { 'className': 'garage-content' }, _createElement('div', {
                'className': 'add-vehicle btn-sm btn btn-primary',
                'onClick': onClick3.bind(this)
            }, [window.Convermax.config?.garageButtonText || _translate(`garage_add_button`)]), _createElement('ul', {}, _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_one`)), _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_two`)), _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_three`))))) : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })]);
}
        export const componentNames = ["cm:garageDropdown"]